import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Environment, Response, User, VendorProfile, VisoPushNotification } from '@viso/core/models';
import { ENVIRONMENT } from '../environment/environment.service';
import { Router } from '@angular/router';
import { Socket } from 'ngx-socket-io';
import { NotificationService } from '@viso/core/data-access';
import { IonicUtilityService, UtilityService } from '@viso/core/utilities';
@Injectable({
  providedIn: 'root',
})
export class UserService {
  private user$ = new BehaviorSubject<User>(null);
  readonly userObservable$ = this.user$.asObservable();

  constructor(
    private http: HttpClient,
    private router: Router,
    @Inject(ENVIRONMENT) private environment: Environment,
    private socket: Socket,
    private notification: NotificationService,
    private ionicUtility: IonicUtilityService,
    private utility: UtilityService
  ) {}

  setUser(value: User) {
    this.user$.next(value);
    return value;
  }

  getUser(update = false) {
    const user = this.user$.getValue();
    if (user && !update) {
      return this.userObservable$;
    }
    return this.http
      .get<Response<User>>(`${this.environment.API_URL}/auth/user`)
      .pipe(
        map((u) => {
          this.socket.on( u.body['user_type'] + "_" + u.body.id, (data: any) => {
            this.notification.startRegistration();
            data['user_type'] = u.body['user_type'];
            // console.log('Notification received', data.props.message.notification);
            const url = this.utility.notificationRedirect(data);
            this.ionicUtility.liveToast(data.props.message.notification.title, data.props.message.notification.body, url);
          });

          this.setUser(u.body);
        }),
        catchError((err) => {
          this.router.navigate(['/welcome'], { replaceUrl: true });
          return of();
        })
      );
  }

  getCurrentUser() {
    const user =  this.user$.getValue();
    return user;
  }

  getVendorProfile(uuid: string) {
    return this.http
      .get<Response<any>>(`${this.environment.API_URL}/vendorProfile/${uuid}`)
      .pipe(map((res: Response<VendorProfile>) => res.body));
  }

  reportVendor(reports) {
    return this.http
    .post(`${this.environment.API_URL}/vendorReport`, reports)
    .pipe(map((res: Response<any>) => res));
  }

  isVendorReported(vendor_id) {
    return this.http
    .post(`${this.environment.API_URL}/client/is-vendor-reported`, {vendor_id})
    .pipe(map((res: Response<any>) => res));
  }

  getVendorEarning(userId: number, userType: string) {
    return this.http
      .get<Response<any>>(`${this.environment.API_URL}/auth/earnings`, {
        params: {
          user_id: userId,
          user_type: userType
        }
      })
      .pipe(map((res: Response<any>) => res.body));
  }

  getSaving(user_id: number, user_type: string): Observable<any> {
  return this.http.get<any>(`${this.environment.API_URL}/auth/savings`, {
    params: { user_id, user_type }
  });
}
}
